<template>
  <div>
    <v-dialog v-model="dialog"
              persistent
              scrollable
              width="500"
    >

      <v-card :disabled="btnLoading"
              :loading="btnLoading">

        <v-card-title>
          {{ titleDialog }}
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">


          <v-text-field outlined
                        label="Montant *"
                        dense
                        type="number"
                        :error-messages="errors.amount"
                        v-model="form.amount"></v-text-field>


          <v-text-field outlined
                        label="Montant affiché *"
                        dense
                        :error-messages="errors.displayed_amount"
                        v-model="form.displayed_amount"></v-text-field>

          <v-autocomplete v-model="form.service_id"
                          :error-messages="errors.service_id"
                          :items="services"
                          item-text="name"
                          :loading="serviceLoading"
                          item-value="id"
                          outlined
                          dense
                          label="Service *"
          />

          <v-file-input ref="file"
                        outlined
                        dense
                        :error-messages="errors.image"
                        accept="image/png, image/jpeg, image/jpg, image/svg, .svg"
                        chips
                        label="Image *"
                        show-size
                        @change="uploadFile"
                        @focus="errors && errors.image ? (errors.image = '') : false"
          />

        </v-card-text>


        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="btnLoading"
                 color="primary"
                 depressed
                 type="submit"
                 @click="save">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>

      </v-card>


    </v-dialog>

  </div>
</template>

<script>

import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      titleDialog: "",
      dialog: false,
      btnLoading: false,
      serviceLoading: false,
      typeLoading: false,
      form: {},
      errors: {},
      services: [],
      types: [],
    }
  },
  methods: {
    uploadFile(file) {
      this.form.image = file;
    },
    open(item) {
      if (!this.services.length){
        this.getServices()
      }
      this.titleDialog = item ? "Modifier un voucher" : "Ajouter un voucher"
      this.dialog = true
      this.errors = {}
      this.form = {
        id: item ? item.id : null,
        amount: item ? item.amount : null,
        displayed_amount: item ? item.displayed_amount : null,
        service_id: item ? item.service_id : null,
        is_displayed: item ? item.is_displayed : true,
        image: null,
      }

      if (this.$refs.file) {
        this.$refs.file.reset();
      }

    },
    close() {
      this.dialog = false
    },
    save() {
      this.errors = {};
      let url = this.form.id ? '/v1/manual-vouchers/update' : "/v1/manual-vouchers/store";
      let formData = new FormData();

      formData.append('id', this.form.id);
      formData.append('amount', this.form.amount);
      formData.append('displayed_amount', this.form.displayed_amount);
      formData.append('service_id', this.form.service_id);
      formData.append('is_displayed', this.form.is_displayed ? 1 : 0);

      if (this.form.image) {
        formData.append('image', this.form.image);
      }

      this.btnLoading = true;

      HTTP.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.btnLoading = false;
        this.$successMessage = "Ce voucher a été enregistré avec succès.";
        this.$emit('refresh');
        if (!this.form.id) {
          this.form = {}
        } else {
          this.close()
        }
      }).catch(err => {
        this.btnLoading = false;
        this.errors = err.response.data.errors;
        this.$errorMessage = "Une erreur s'est produite veuillez corriger.";
        console.log(err);
      });
    },
    getServices() {
      this.serviceLoading = true
      HTTP.get("/service?size=1000", {params: {}}).then((res) => {
        this.services = res.data.data.filter(el => el.is_instant_voucher === 0);
        this.serviceLoading = false
      }).catch((err) => {
        console.log(err);
        this.serviceLoading = false
      });
    },
  }
}
</script>

